import LogoImg from 'src/assets/ic_launcher.png';
const Logo = (props) => <img alt="Logo" src={LogoImg} {...props} />;

export default Logo;
